import type { ReactNode } from "react";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { blue } from "@mui/material/colors";

interface ReconciliationDispatchSummaryCardProps {
  label: string;
  value: ReactNode;
}

/** A single snapshot tile (label + value) for the dispatch reconciliation summary row. */
export const ReconciliationDispatchSummaryCard = (props: ReconciliationDispatchSummaryCardProps) => {
  const { label, value } = props;
  return (
    <Paper
      variant="outlined"
      sx={{ flex: 1, p: 2, background: blue[50] }}
    >
      <Typography sx={{ fontSize: 28, fontWeight: 700, lineHeight: 1.2 }}>
        {value}
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
      >
        {label}
      </Typography>
    </Paper>
  );
};
